/* =====================================================================
 * StorageEmptyState — 빈 목록 / 검색결과 없음
 * ===================================================================== */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { FolderOpen, Search } from 'lucide-react';
import { EmptyWrap, EmptyIcon, EmptyTitle, EmptySub } from './storage.styles';

interface Props {
  /** 검색 결과 없음 모드 */
  isSearchEmpty?: boolean;
  searchQuery?: string;
}

export const StorageEmptyState: React.FC<Props> = ({
  isSearchEmpty,
  searchQuery,
}) => {
  const { t } = useTranslation('common');
  if (isSearchEmpty) {
    return (
      <EmptyWrap>
        <EmptyIcon>
          <Search size={32} />
        </EmptyIcon>
        <EmptyTitle>{t('search.noResults')}</EmptyTitle>
        <EmptySub>
          {t('storage.noMatchingFiles', { query: searchQuery })}
        </EmptySub>
      </EmptyWrap>
    );
  }

  return (
    <EmptyWrap>
      <EmptyIcon>
        <FolderOpen size={32} />
      </EmptyIcon>
      <EmptyTitle>{t('storage.noFiles')}</EmptyTitle>
      <EmptySub>{t('storage.noFilesDesc')}</EmptySub>
    </EmptyWrap>
  );
};
